import { TextEditorFont } from '@/containers/TextEditor/types';

export const replyStopMessage = 'Reply STOP to opt-out';

export const textEditorFonts: TextEditorFont[] = [
  {
    name: 'regular',
    label: 'Regular',
    regular: true,
    bold: true,
    italic: true,
    boldItalic: false,
  },
  {
    name: 'sans-serif',
    label: '𝖲𝖺𝗇𝗌 𝖲𝖾𝗋𝗂𝖿',
    regular: true,
    bold: true,
    italic: true,
    boldItalic: true,
  },
  {
    name: 'serif',
    label: '𝐒𝐞𝐫𝐢𝐟',
    regular: false,
    bold: true,
    italic: false,
    boldItalic: true,
  },
  {
    name: 'script',
    label: '𝓒𝓾𝓻𝓼𝓲𝓿𝓮',
    regular: true,
    bold: false,
    italic: false,
    boldItalic: false,
  },
  {
    name: 'double-struck',
    label: '𝔹𝕠𝕝𝕕 𝕆𝕦𝕥𝕝𝕚𝕟𝕖',
    regular: true,
    bold: false,
    italic: false,
    boldItalic: false,
  },
  {
    name: 'block',
    label: '🄱🄻🄾🄲🄺',
    regular: true,
    bold: false,
    italic: false,
    boldItalic: false,
  },
  {
    name: 'solid-block',
    label: '🅱🅻🅾🅲🅺 🅿🅰🆁🆃🆈',
    regular: true,
    bold: false,
    italic: false,
    boldItalic: false,
  },
  {
    name: 'circle',
    label: 'Ⓒⓘⓡⓒⓛⓔⓓ',
    regular: true,
    bold: false,
    italic: false,
    boldItalic: false,
  },
  {
    name: 'solid-circle',
    label: '🅒🅘🅡🅒🅛🅔 🅣🅔🅧🅣',
    regular: true,
    bold: false,
    italic: false,
    boldItalic: false,
  },
  {
    name: 'gothic',
    label: '𝔎𝔦𝔫𝔤𝔡𝔬𝔪',
    regular: true,
    bold: true,
    italic: false,
    boldItalic: false,
  },
  {
    name: 'small-caps',
    label: 'ᴍɪɴɪᴄᴀᴩꜱ',
    regular: true,
    bold: false,
    italic: false,
    boldItalic: false,
  },
  {
    name: 'spaced',
    label: 'Ｓｐａｃｅｄ',
    regular: true,
    bold: false,
    italic: false,
    boldItalic: false,
  },
  {
    name: 'monospace',
    label: '𝙼𝚘𝚗𝚘𝚜𝚙𝚊𝚌𝚎',
    regular: true,
    bold: false,
    italic: false,
    boldItalic: false,
  },
  {
    name: 'superscript',
    label: 'ˢᵘᵖᵉʳˢᶜʳⁱᵖᵗ',
    regular: true,
    bold: false,
    italic: false,
    boldItalic: false,
  },
];

// Generating new fonts
// 1. Navigate to https://texteditor.com/font-converter/
// 2. Enter text 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
// 3. Copy the font choice
// 4.Paste into a new map separating each char into its own element in an array using the below references

export const UnicodeRegular = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
  'a',
  'b',
  'c',
  'd',
  'e',
  'f',
  'g',
  'h',
  'i',
  'j',
  'k',
  'l',
  'm',
  'n',
  'o',
  'p',
  'q',
  'r',
  's',
  't',
  'u',
  'v',
  'w',
  'x',
  'y',
  'z',
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
];

export const UnicodeMap = new Map<string, string[]>([
  ['regular', UnicodeRegular],
  [
    'serif-bold',
    [
      '𝐀',
      '𝐁',
      '𝐂',
      '𝐃',
      '𝐄',
      '𝐅',
      '𝐆',
      '𝐇',
      '𝐈',
      '𝐉',
      '𝐊',
      '𝐋',
      '𝐌',
      '𝐍',
      '𝐎',
      '𝐏',
      '𝐐',
      '𝐑',
      '𝐒',
      '𝐓',
      '𝐔',
      '𝐕',
      '𝐖',
      '𝐗',
      '𝐘',
      '𝐙',
      '𝐚',
      '𝐛',
      '𝐜',
      '𝐝',
      '𝐞',
      '𝐟',
      '𝐠',
      '𝐡',
      '𝐢',
      '𝐣',
      '𝐤',
      '𝐥',
      '𝐦',
      '𝐧',
      '𝐨',
      '𝐩',
      '𝐪',
      '𝐫',
      '𝐬',
      '𝐭',
      '𝐮',
      '𝐯',
      '𝐰',
      '𝐱',
      '𝐲',
      '𝐳',
      '𝟎',
      '𝟏',
      '𝟐',
      '𝟑',
      '𝟒',
      '𝟓',
      '𝟔',
      '𝟕',
      '𝟖',
      '𝟗',
    ],
  ],
  [
    'serif-bold-italic',
    [
      '𝑨',
      '𝑩',
      '𝑪',
      '𝑫',
      '𝑬',
      '𝑭',
      '𝑮',
      '𝑯',
      '𝑰',
      '𝑱',
      '𝑲',
      '𝑳',
      '𝑴',
      '𝑵',
      '𝑶',
      '𝑷',
      '𝑸',
      '𝑹',
      '𝑺',
      '𝑻',
      '𝑼',
      '𝑽',
      '𝑾',
      '𝑿',
      '𝒀',
      '𝒁',
      '𝒂',
      '𝒃',
      '𝒄',
      '𝒅',
      '𝒆',
      '𝒇',
      '𝒈',
      '𝒉',
      '𝒊',
      '𝒋',
      '𝒌',
      '𝒍',
      '𝒎',
      '𝒏',
      '𝒐',
      '𝒑',
      '𝒒',
      '𝒓',
      '𝒔',
      '𝒕',
      '𝒖',
      '𝒗',
      '𝒘',
      '𝒙',
      '𝒚',
      '𝒛',
      '𝟎',
      '𝟏',
      '𝟐',
      '𝟑',
      '𝟒',
      '𝟓',
      '𝟔',
      '𝟕',
      '𝟖',
      '𝟗',
    ],
  ],
  [
    'double-struck',
    [
      '𝔸',
      '𝔹',
      'ℂ',
      '𝔻',
      '𝔼',
      '𝔽',
      '𝔾',
      'ℍ',
      '𝕀',
      '𝕁',
      '𝕂',
      '𝕃',
      '𝕄',
      'ℕ',
      '𝕆',
      'ℙ',
      'ℚ',
      'ℝ',
      '𝕊',
      '𝕋',
      '𝕌',
      '𝕍',
      '𝕎',
      '𝕏',
      '𝕐',
      'ℤ',
      '𝕒',
      '𝕓',
      '𝕔',
      '𝕕',
      '𝕖',
      '𝕗',
      '𝕘',
      '𝕙',
      '𝕚',
      '𝕛',
      '𝕜',
      '𝕝',
      '𝕞',
      '𝕟',
      '𝕠',
      '𝕡',
      '𝕢',
      '𝕣',
      '𝕤',
      '𝕥',
      '𝕦',
      '𝕧',
      '𝕨',
      '𝕩',
      '𝕪',
      '𝕫',
      '𝟘',
      '𝟙',
      '𝟚',
      '𝟛',
      '𝟜',
      '𝟝',
      '𝟞',
      '𝟟',
      '𝟠',
      '𝟡',
    ],
  ],
  [
    'script',
    [
      '𝓐',
      '𝓑',
      '𝓒',
      '𝓓',
      '𝓔',
      '𝓕',
      '𝓖',
      '𝓗',
      '𝓘',
      '𝓙',
      '𝓚',
      '𝓛',
      '𝓜',
      '𝓝',
      '𝓞',
      '𝓟',
      '𝓠',
      '𝓡',
      '𝓢',
      '𝓣',
      '𝓤',
      '𝓥',
      '𝓦',
      '𝓧',
      '𝓨',
      '𝓩',
      '𝓪',
      '𝓫',
      '𝓬',
      '𝓭',
      '𝓮',
      '𝓯',
      '𝓰',
      '𝓱',
      '𝓲',
      '𝓳',
      '𝓴',
      '𝓵',
      '𝓶',
      '𝓷',
      '𝓸',
      '𝓹',
      '𝓺',
      '𝓻',
      '𝓼',
      '𝓽',
      '𝓾',
      '𝓿',
      '𝔀',
      '𝔁',
      '𝔂',
      '𝔃',
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
    ],
  ],
  [
    'sans-serif-bold',
    [
      '𝗔',
      '𝗕',
      '𝗖',
      '𝗗',
      '𝗘',
      '𝗙',
      '𝗚',
      '𝗛',
      '𝗜',
      '𝗝',
      '𝗞',
      '𝗟',
      '𝗠',
      '𝗡',
      '𝗢',
      '𝗣',
      '𝗤',
      '𝗥',
      '𝗦',
      '𝗧',
      '𝗨',
      '𝗩',
      '𝗪',
      '𝗫',
      '𝗬',
      '𝗭',
      '𝗮',
      '𝗯',
      '𝗰',
      '𝗱',
      '𝗲',
      '𝗳',
      '𝗴',
      '𝗵',
      '𝗶',
      '𝗷',
      '𝗸',
      '𝗹',
      '𝗺',
      '𝗻',
      '𝗼',
      '𝗽',
      '𝗾',
      '𝗿',
      '𝘀',
      '𝘁',
      '𝘂',
      '𝘃',
      '𝘄',
      '𝘅',
      '𝘆',
      '𝘇',
      '𝟬',
      '𝟭',
      '𝟮',
      '𝟯',
      '𝟰',
      '𝟱',
      '𝟲',
      '𝟳',
      '𝟴',
      '𝟵',
    ],
  ],
  [
    'sans-serif-italic',
    [
      '𝘈',
      '𝘉',
      '𝘊',
      '𝘋',
      '𝘌',
      '𝘍',
      '𝘎',
      '𝘏',
      '𝘐',
      '𝘑',
      '𝘒',
      '𝘓',
      '𝘔',
      '𝘕',
      '𝘖',
      '𝘗',
      '𝘘',
      '𝘙',
      '𝘚',
      '𝘛',
      '𝘜',
      '𝘝',
      '𝘞',
      '𝘟',
      '𝘠',
      '𝘡',
      '𝘢',
      '𝘣',
      '𝘤',
      '𝘥',
      '𝘦',
      '𝘧',
      '𝘨',
      '𝘩',
      '𝘪',
      '𝘫',
      '𝘬',
      '𝘭',
      '𝘮',
      '𝘯',
      '𝘰',
      '𝘱',
      '𝘲',
      '𝘳',
      '𝘴',
      '𝘵',
      '𝘶',
      '𝘷',
      '𝘸',
      '𝘹',
      '𝘺',
      '𝘻',
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
    ],
  ],
  [
    'sans-serif-bold-italic',
    [
      '𝘼',
      '𝘽',
      '𝘾',
      '𝘿',
      '𝙀',
      '𝙁',
      '𝙂',
      '𝙃',
      '𝙄',
      '𝙅',
      '𝙆',
      '𝙇',
      '𝙈',
      '𝙉',
      '𝙊',
      '𝙋',
      '𝙌',
      '𝙍',
      '𝙎',
      '𝙏',
      '𝙐',
      '𝙑',
      '𝙒',
      '𝙓',
      '𝙔',
      '𝙕',
      '𝙖',
      '𝙗',
      '𝙘',
      '𝙙',
      '𝙚',
      '𝙛',
      '𝙜',
      '𝙝',
      '𝙞',
      '𝙟',
      '𝙠',
      '𝙡',
      '𝙢',
      '𝙣',
      '𝙤',
      '𝙥',
      '𝙦',
      '𝙧',
      '𝙨',
      '𝙩',
      '𝙪',
      '𝙫',
      '𝙬',
      '𝙭',
      '𝙮',
      '𝙯',
      '𝟎',
      '𝟏',
      '𝟐',
      '𝟑',
      '𝟒',
      '𝟓',
      '𝟔',
      '𝟕',
      '𝟖',
      '𝟗',
    ],
  ],
  [
    'block',
    [
      '🄰',
      '🄱',
      '🄲',
      '🄳',
      '🄴',
      '🄵',
      '🄶',
      '🄷',
      '🄸',
      '🄹',
      '🄺',
      '🄻',
      '🄼',
      '🄽',
      '🄾',
      '🄿',
      '🅀',
      '🅁',
      '🅂',
      '🅃',
      '🅄',
      '🅅',
      '🅆',
      '🅇',
      '🅈',
      '🅉',
      '🄰',
      '🄱',
      '🄲',
      '🄳',
      '🄴',
      '🄵',
      '🄶',
      '🄷',
      '🄸',
      '🄹',
      '🄺',
      '🄻',
      '🄼',
      '🄽',
      '🄾',
      '🄿',
      '🅀',
      '🅁',
      '🅂',
      '🅃',
      '🅄',
      '🅅',
      '🅆',
      '🅇',
      '🅈',
      '🅉',
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
    ],
  ],
  [
    'gothic',
    [
      '𝔄',
      '𝔅',
      'ℭ',
      '𝔇',
      '𝔈',
      '𝔉',
      '𝔊',
      'ℌ',
      'ℑ',
      '𝔍',
      '𝔎',
      '𝔏',
      '𝔐',
      '𝔑',
      '𝔒',
      '𝔓',
      '𝔔',
      'ℜ',
      '𝔖',
      '𝔗',
      '𝔘',
      '𝔙',
      '𝔚',
      '𝔛',
      '𝔜',
      'ℨ',
      '𝔞',
      '𝔟',
      '𝔠',
      '𝔡',
      '𝔢',
      '𝔣',
      '𝔤',
      '𝔥',
      '𝔦',
      '𝔧',
      '𝔨',
      '𝔩',
      '𝔪',
      '𝔫',
      '𝔬',
      '𝔭',
      '𝔮',
      '𝔯',
      '𝔰',
      '𝔱',
      '𝔲',
      '𝔳',
      '𝔴',
      '𝔵',
      '𝔶',
      '𝔷',
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
    ],
  ],
  [
    'gothic-bold',
    [
      '𝕬',
      '𝕭',
      '𝕮',
      '𝕯',
      '𝕰',
      '𝕱',
      '𝕲',
      '𝕳',
      '𝕴',
      '𝕵',
      '𝕶',
      '𝕷',
      '𝕸',
      '𝕹',
      '𝕺',
      '𝕻',
      '𝕼',
      '𝕽',
      '𝕾',
      '𝕿',
      '𝖀',
      '𝖁',
      '𝖂',
      '𝖃',
      '𝖄',
      '𝖅',
      '𝖆',
      '𝖇',
      '𝖈',
      '𝖉',
      '𝖊',
      '𝖋',
      '𝖌',
      '𝖍',
      '𝖎',
      '𝖏',
      '𝖐',
      '𝖑',
      '𝖒',
      '𝖓',
      '𝖔',
      '𝖕',
      '𝖖',
      '𝖗',
      '𝖘',
      '𝖙',
      '𝖚',
      '𝖛',
      '𝖜',
      '𝖝',
      '𝖞',
      '𝖟',
      '𝟎',
      '𝟏',
      '𝟐',
      '𝟑',
      '𝟒',
      '𝟓',
      '𝟔',
      '𝟕',
      '𝟖',
      '𝟗',
    ],
  ],
  [
    'small-caps',
    [
      'ᴀ',
      'ʙ',
      'ᴄ',
      'ᴅ',
      'ᴇ',
      'ꜰ',
      'ɢ',
      'ʜ',
      'ɪ',
      'ᴊ',
      'ᴋ',
      'ʟ',
      'ᴍ',
      'ɴ',
      'ᴏ',
      'ᴩ',
      'Q',
      'ʀ',
      'ꜱ',
      'ᴛ',
      'ᴜ',
      'ᴠ',
      'ᴡ',
      'x',
      'Y',
      'ᴢ',
      'ᴀ',
      'ʙ',
      'ᴄ',
      'ᴅ',
      'ᴇ',
      'ꜰ',
      'ɢ',
      'ʜ',
      'ɪ',
      'ᴊ',
      'ᴋ',
      'ʟ',
      'ᴍ',
      'ɴ',
      'ᴏ',
      'ᴩ',
      'q',
      'ʀ',
      'ꜱ',
      'ᴛ',
      'ᴜ',
      'ᴠ',
      'ᴡ',
      'x',
      'y',
      'ᴢ',
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
    ],
  ],
  [
    'monospace',
    [
      '𝙰',
      '𝙱',
      '𝙲',
      '𝙳',
      '𝙴',
      '𝙵',
      '𝙶',
      '𝙷',
      '𝙸',
      '𝙹',
      '𝙺',
      '𝙻',
      '𝙼',
      '𝙽',
      '𝙾',
      '𝙿',
      '𝚀',
      '𝚁',
      '𝚂',
      '𝚃',
      '𝚄',
      '𝚅',
      '𝚆',
      '𝚇',
      '𝚈',
      '𝚉',
      '𝚊',
      '𝚋',
      '𝚌',
      '𝚍',
      '𝚎',
      '𝚏',
      '𝚐',
      '𝚑',
      '𝚒',
      '𝚓',
      '𝚔',
      '𝚕',
      '𝚖',
      '𝚗',
      '𝚘',
      '𝚙',
      '𝚚',
      '𝚛',
      '𝚜',
      '𝚝',
      '𝚞',
      '𝚟',
      '𝚠',
      '𝚡',
      '𝚢',
      '𝚣',
      '𝟶',
      '𝟷',
      '𝟸',
      '𝟹',
      '𝟺',
      '𝟻',
      '𝟼',
      '𝟽',
      '𝟾',
      '𝟿',
    ],
  ],
  [
    'superscript',
    [
      'ᴬ',
      'ᴮ',
      'ᶜ',
      'ᴰ',
      'ᴱ',
      'ᶠ',
      'ᴳ',
      'ᴴ',
      'ᴵ',
      'ᴶ',
      'ᴷ',
      'ᴸ',
      'ᴹ',
      'ᴺ',
      'ᴼ',
      'ᴾ',
      'Q',
      'ᴿ',
      'ˢ',
      'ᵀ',
      'ᵁ',
      'ⱽ',
      'ᵂ',
      'ˣ',
      'ʸ',
      'ᶻ',
      'ᵃ',
      'ᵇ',
      'ᶜ',
      'ᵈ',
      'ᵉ',
      'ᶠ',
      'ᵍ',
      'ʰ',
      'ⁱ',
      'ʲ',
      'ᵏ',
      'ˡ',
      'ᵐ',
      'ⁿ',
      'ᵒ',
      'ᵖ',
      'q',
      'ʳ',
      'ˢ',
      'ᵗ',
      'ᵘ',
      'ᵛ',
      'ʷ',
      'ˣ',
      'ʸ',
      'ᶻ',
      '⁰',
      '¹',
      '²',
      '³',
      '⁴',
      '⁵',
      '⁶',
      '⁷',
      '⁸',
      '⁹',
    ],
  ],
  [
    'circle',
    [
      'Ⓐ',
      'Ⓑ',
      'Ⓒ',
      'Ⓓ',
      'Ⓔ',
      'Ⓕ',
      'Ⓖ',
      'Ⓗ',
      'Ⓘ',
      'Ⓙ',
      'Ⓚ',
      'Ⓛ',
      'Ⓜ',
      'Ⓝ',
      'Ⓞ',
      'Ⓟ',
      'Ⓠ',
      'Ⓡ',
      'Ⓢ',
      'Ⓣ',
      'Ⓤ',
      'Ⓥ',
      'Ⓦ',
      'Ⓧ',
      'Ⓨ',
      'Ⓩ',
      'ⓐ',
      'ⓑ',
      'ⓒ',
      'ⓓ',
      'ⓔ',
      'ⓕ',
      'ⓖ',
      'ⓗ',
      'ⓘ',
      'ⓙ',
      'ⓚ',
      'ⓛ',
      'ⓜ',
      'ⓝ',
      'ⓞ',
      'ⓟ',
      'ⓠ',
      'ⓡ',
      'ⓢ',
      'ⓣ',
      'ⓤ',
      'ⓥ',
      'ⓦ',
      'ⓧ',
      'ⓨ',
      'ⓩ',
      '0',
      '①',
      '②',
      '③',
      '④',
      '⑤',
      '⑥',
      '⑦',
      '⑧',
      '⑨',
    ],
  ],
  [
    'solid-circle',
    [
      '🅐',
      '🅑',
      '🅒',
      '🅓',
      '🅔',
      '🅕',
      '🅖',
      '🅗',
      '🅘',
      '🅙',
      '🅚',
      '🅛',
      '🅜',
      '🅝',
      '🅞',
      '🅟',
      '🅠',
      '🅡',
      '🅢',
      '🅣',
      '🅤',
      '🅥',
      '🅦',
      '🅧',
      '🅨',
      '🅩',
      '🅐',
      '🅑',
      '🅒',
      '🅓',
      '🅔',
      '🅕',
      '🅖',
      '🅗',
      '🅘',
      '🅙',
      '🅚',
      '🅛',
      '🅜',
      '🅝',
      '🅞',
      '🅟',
      '🅠',
      '🅡',
      '🅢',
      '🅣',
      '🅤',
      '🅥',
      '🅦',
      '🅧',
      '🅨',
      '🅩',
      '𝟎',
      '𝟏',
      '𝟐',
      '𝟑',
      '𝟒',
      '𝟓',
      '𝟔',
      '𝟕',
      '𝟖',
      '𝟗',
    ],
  ],
  [
    'solid-block',
    [
      '🅰',
      '🅱',
      '🅲',
      '🅳',
      '🅴',
      '🅵',
      '🅶',
      '🅷',
      '🅸',
      '🅹',
      '🅺',
      '🅻',
      '🅼',
      '🅽',
      '🅾',
      '🅿',
      '🆀',
      '🆁',
      '🆂',
      '🆃',
      '🆄',
      '🆅',
      '🆆',
      '🆇',
      '🆈',
      '🆉',
      '🅰',
      '🅱',
      '🅲',
      '🅳',
      '🅴',
      '🅵',
      '🅶',
      '🅷',
      '🅸',
      '🅹',
      '🅺',
      '🅻',
      '🅼',
      '🅽',
      '🅾',
      '🅿',
      '🆀',
      '🆁',
      '🆂',
      '🆃',
      '🆄',
      '🆅',
      '🆆',
      '🆇',
      '🆈',
      '🆉',
      '𝟎',
      '𝟏',
      '𝟐',
      '𝟑',
      '𝟒',
      '𝟓',
      '𝟔',
      '𝟕',
      '𝟖',
      '𝟗',
    ],
  ],
  [
    'spaced',
    [
      'Ａ',
      'Ｂ',
      'Ｃ',
      'Ｄ',
      'Ｅ',
      'Ｆ',
      'Ｇ',
      'Ｈ',
      'Ｉ',
      'Ｊ',
      'Ｋ',
      'Ｌ',
      'Ｍ',
      'Ｎ',
      'Ｏ',
      'Ｐ',
      'Ｑ',
      'Ｒ',
      'Ｓ',
      'Ｔ',
      'Ｕ',
      'Ｖ',
      'Ｗ',
      'Ｘ',
      'Ｙ',
      'Ｚ',
      'ａ',
      'ｂ',
      'ｃ',
      'ｄ',
      'ｅ',
      'ｆ',
      'ｇ',
      'ｈ',
      'ｉ',
      'ｊ',
      'ｋ',
      'ｌ',
      'ｍ',
      'ｎ',
      'ｏ',
      'ｐ',
      'ｑ',
      'ｒ',
      'ｓ',
      'ｔ',
      'ｕ',
      'ｖ',
      'ｗ',
      'ｘ',
      'ｙ',
      'ｚ',
      '０',
      '１',
      '２',
      '３',
      '４',
      '５',
      '６',
      '７',
      '８',
      '９',
    ],
  ],
  [
    'sans-serif',
    [
      '𝖠',
      '𝖡',
      '𝖢',
      '𝖣',
      '𝖤',
      '𝖥',
      '𝖦',
      '𝖧',
      '𝖨',
      '𝖩',
      '𝖪',
      '𝖫',
      '𝖬',
      '𝖭',
      '𝖮',
      '𝖯',
      '𝖰',
      '𝖱',
      '𝖲',
      '𝖳',
      '𝖴',
      '𝖵',
      '𝖶',
      '𝖷',
      '𝖸',
      '𝖹',
      '𝖺',
      '𝖻',
      '𝖼',
      '𝖽',
      '𝖾',
      '𝖿',
      '𝗀',
      '𝗁',
      '𝗂',
      '𝗃',
      '𝗄',
      '𝗅',
      '𝗆',
      '𝗇',
      '𝗈',
      '𝗉',
      '𝗊',
      '𝗋',
      '𝗌',
      '𝗍',
      '𝗎',
      '𝗏',
      '𝗐',
      '𝗑',
      '𝗒',
      '𝗓',
      '𝟢',
      '𝟣',
      '𝟤',
      '𝟥',
      '𝟦',
      '𝟧',
      '𝟨',
      '𝟩',
      '𝟪',
      '𝟫',
    ],
  ],
]);

export const defaultTextEditorFont = textEditorFonts.find(
  (f) => f.name === 'regular'
) as TextEditorFont;
export const maxLengthForMms = 2000;
